import './Services.css';

function SrvPSI5Interface() {
  const psi5Items = [
    { title: '통신방식', value: 'PSI5 (Peripheral Sensor Interface 5) 단방향/양방향 통신 지원' },
    { title: '지원센서', value: '자동차용 속도 센서, 압력 센서, 충격 센서 등' },
    { title: '동작전압', value: '24V DC' },
    { title: '통신속도', value: '125kbps, 189kbps 등 선택 가능' },
    { title: '적용분야', value: '자동차, 산업용 계측, 센서 인터페이스 및 롬라이팅' },
    { title: '인터페이스', value: 'PC 및 기타 MCU와의 연동 지원' },
    { title: '기능특징', value: '이중화 통신, 센서 전원 공급, 통신 안정성 강화' }
  ];

  return (
    <div className="overview-container">
      <div className="section-title-box">PSI5 롬라이터</div>

      <div className="services-header">
        <div className="services-image">
          <img src="/images/PSI5_Board.png" alt="PSI5 인터페이스 구성" />
        </div>
        <div className="services-text">
          <p>
            PSI5 롬라이터는 자동차용 센서를 사용환경에 대응하여 동작하도록 OTP 롬라이팅을 하는 기기입니다.<br /> 
            생산현장에서 장시간 다양한 센서를 통해 검증되어 PSI5를 사용하는 각종 센서 제조공정에 최적의 성능을 제공합니다.
          </p>
        </div>
      </div>

      <div className="overview-table">
        {psi5Items.map((item, index) => (
          <div key={index} className="overview-row">
            <div className="overview-title">{item.title}</div>
            <div className="overview-value">{item.value}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default SrvPSI5Interface;
